var _path, _path2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8426 19.3447H17.9344V17.4365C17.9344 17.2224 17.7609 17.0488 17.5468 17.0488C17.3327 17.0488 17.1591 17.2224 17.1591 17.4365V19.3447H15.2509C15.0368 19.3447 14.8633 19.5183 14.8633 19.7324C14.8633 19.9465 15.0368 20.12 15.2509 20.12H17.1591V22.0282C17.1591 22.2423 17.3327 22.4159 17.5468 22.4159C17.761 22.4159 17.9344 22.2423 17.9344 22.0282V20.12H19.8426C20.0568 20.12 20.2303 19.9465 20.2303 19.7324C20.2303 19.5183 20.0568 19.3447 19.8426 19.3447Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2432 17.6017C21.1361 17.4163 20.8989 17.3529 20.7136 17.46C20.5282 17.5671 20.4648 17.8042 20.5719 17.9896C20.8773 18.5183 21.0388 19.1211 21.0388 19.7329C21.0388 21.6583 19.4723 23.2247 17.5469 23.2247C16.527 23.2247 15.608 22.785 14.9689 22.0854C14.9663 22.0825 14.9636 22.0797 14.9609 22.0768C14.3828 21.4406 14.0551 20.5926 14.0551 19.7329C14.0551 17.8075 15.6215 16.241 17.5469 16.241C18.3017 16.241 19.0421 16.488 19.645 16.9417C19.8161 17.0705 20.0592 17.0362 20.1879 16.8652C20.3167 16.6941 20.2824 16.4511 20.1114 16.3223C19.719 16.0269 19.2869 15.8057 18.8293 15.6618V3.63399C18.8293 3.53119 18.7885 3.43257 18.7158 3.35987L15.4695 0.113578C15.3968 0.0408282 15.2982 0 15.1954 0H2.5732C2.35903 0 2.18555 0.173579 2.18555 0.387657V2.61408C2.18555 2.82816 2.35908 3.00174 2.5732 3.00174C2.78733 3.00174 2.96086 2.82816 2.96086 2.61408V0.775361H11.2493V6.26992C11.2493 6.45723 11.3822 6.61356 11.5588 6.64975C11.5841 6.6549 11.6102 6.65767 11.637 6.65767H18.0539V15.4955C18.053 15.4711 17.5877 15.4658 17.5468 15.4658C15.1939 15.4658 13.2797 17.38 13.2797 19.7329C13.2797 20.4117 13.4461 21.0925 13.7591 21.6946C13.8494 21.8684 13.9513 22.0367 14.0643 22.1967H2.96086V4.1648C2.96086 3.95073 2.78733 3.77715 2.5732 3.77715C2.35908 3.77715 2.18555 3.95073 2.18555 4.1648V22.5843C2.18555 22.7984 2.35908 22.972 2.5732 22.972H14.7738C15.5202 23.612 16.4889 24 17.547 24C19.8998 24 21.8141 22.0858 21.8141 19.7329C21.8141 18.9851 21.6167 18.2481 21.2432 17.6017Z",
    fill: "#263238"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 11,
    height: 1,
    rx: 0.5,
    fill: "#263238"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 11,
    height: 1,
    rx: 0.5,
    fill: "#263238"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 7,
    height: 1,
    rx: 0.5,
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocs);
export default __webpack_public_path__ + "static/media/upload-docs.08877f5d6c834771f038a231b77349a7.svg";
export { ForwardRef as ReactComponent };